import { render, staticRenderFns } from "./SelectAjaxModal.vue?vue&type=template&id=135a4546&scoped=true&"
import script from "./SelectAjaxModal.vue?vue&type=script&lang=js&"
export * from "./SelectAjaxModal.vue?vue&type=script&lang=js&"
import style0 from "./SelectAjaxModal.vue?vue&type=style&index=0&id=135a4546&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135a4546",
  null
  
)

export default component.exports